<template>
  <div class="home-page-2">
    <div class="left-box">
      <div class="box-title">设备情况</div>
      <div class="page2-content">
        <pie-chart ref="pieChart"></pie-chart>
      </div>
    </div>
    <div class="right-box">
      <div class="box-title">用户情况</div>
      <div class="page2-content">
        <pie-chart1 ref="pieChart1"></pie-chart1>
      </div>
    </div>
    <div class="right-box">
      <div class="box-title">订单情况</div>
      <div class="page2-content">
        <pie-chart2 ref="pieChart2"></pie-chart2>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDeviceDistribute,
  getOrderDistribute,
  getUserDistribute,
} from "@/views/HomePage/api";
import pieChart from "./echarts/pieChart.vue";
import pieChart1 from "./echarts/pieChart1.vue";
import pieChart2 from "./echarts/pieChart2.vue";
export default {
  name: "OrderOverview",
  components: { pieChart, pieChart1, pieChart2 },
  data() {
    return {
      detail: {
        todayNum: 2000,
      },
      lineData1: [],
      lineData2: [],
      lineData3: [],
    };
  },
  mounted() {
    // this.$refs.pieChart1.initChart(this.lineData);
    // this.$refs.pieChart2.initChart(this.lineData);
    this.getDetail1();
    this.getDetail2();
    this.getDetail3();
  },
  methods: {
    getDetail1() {
      getDeviceDistribute().then((res) => {
        if (res.code === 200) {
          this.lineData1 = res.data.distribute;
          this.$refs.pieChart.initChart(this.lineData1);
        }
      });
    },
    getDetail2() {
      getUserDistribute().then((res) => {
        if (res.code === 200) {
          this.lineData2 = res.data.distribute;
          this.$refs.pieChart1.initChart(this.lineData2);
        }
      });
    },
    getDetail3() {
      getOrderDistribute().then((res) => {
        if (res.code === 200) {
          this.lineData3 = res.data.distribute;
          this.$refs.pieChart2.initChart(this.lineData3);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home-page-2 {
  width: 100%;
  height: 4rem;
  margin-bottom: 0.16rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .left-box {
    width: 33.333%;
    background-color: #ffffff;
    padding: 0.2rem 0.16rem 0;
    border-radius: 0.08rem;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }
  .right-box {
    flex: 1;
    margin-left: 0.16rem;
    background-color: #ffffff;
    padding: 0.2rem 0.16rem 0;
    border-radius: 0.08rem;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }
  .box-title {
    font-weight: 500;
    font-size: 0.16rem;
    color: #1f2329;
    padding-bottom: 0.16rem;
    flex-shrink: 0;
  }
  .page2-content {
    width: 100%;
    flex: 1;
    padding-bottom: 0.2rem;
  }
}
</style>
